// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link--VwcG6","linkIcon":"styles__linkIcon--2hE2G","linkIconExpanded":"styles__linkIconExpanded--qBrbd"};
    if(module.hot) {
      // 1545480340980
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  